import { useEffect } from 'react';

/**
 * Attaches an IntersectionObserver to every `.reveal` element in the DOM.
 * Adds the `.visible` class when an element enters the viewport,
 * triggering the CSS fade-up transition defined in global.css.
 *
 * Call this hook once at the App root so it scans the full rendered tree.
 */
export function useScrollReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.12 }
    );

    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
}
